import Constants from "@/services/Constants";
import AuthService from "./AuthService";

const OSS = require("ali-oss");

let client = null;

export default {
	async init() {
		let res = await AuthService.axios().get(`${Constants.adminBackend}/gallery/options`);
		client = new OSS(res.data);
	},
	async list() {
		let marker = null;
		let result = [];
		do {
			let partialResult = await client.list({
				marker,
				'max-keys': 100
			});
			result = result.concat(partialResult.objects);
			marker = partialResult.nextMarker;
		} while (marker);
		return result;
	},
	async upload(path) {
		let rand = "xxxxxxxx".replace(/x/g,
			() => (Math.random() * 16 | 0).toString(16));
		let filename = String(Date.now() % 1e12) + "-" + rand + ".jpg";
		await client.put(filename, path);
	}
};